/* import './bootstrap';

import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start(); */

/* window.$ = window.jQuery = require('jquery');
window.bootstrap = require('bootstrap');

import 'bootstrap/js/dist/modal';
import 'jquery-ui/ui/widgets/autocomplete';
import 'jquery-ui/ui/widgets/sortable'; */

window.Toastify = require('toastify-js');
import "toastify-js/src/toastify.css";

import Swal from 'sweetalert2';
window.Swal = Swal;

// Traduzioni
const messages = {
    en: {
        confirmDelete: "Yes, delete!",
        cancel: "Cancel",
        revertMessage: "You won't be able to revert this!",
    },
    it: {
        confirmDelete: "Sì, elimina!",
        cancel: "Annulla",
        revertMessage: "Non sarà possibile tornare indietro!",
    },
}

document.addEventListener('DOMContentLoaded', function () {
    const alert = (function () {
        const currentLocale = window.App.locale;

        function confirmDelete({ title, cb = null }) {
            return Swal.fire({
                title,
                text: messages[currentLocale].revertMessage,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: messages[currentLocale].confirmDelete,
                cancelButtonText: messages[currentLocale].cancel,
            }).then((result) => {
                if (result.isConfirmed && !!cb) {
                    cb();
                }
            });
        }

        function error({ message }) {
            return Swal.fire({
                icon: "error",
                title: "Oops...",
                text: message,
            });
        }

        function success({ title = 'Success!', message = 'Your action has been completed successfully.', cb = null }) {
            return Swal.fire({
                title,
                text: message,
                icon: 'success',
                confirmButtonText: 'OK',
                timer: 3000,
                timerProgressBar: true
            }).then((result) => {
                if (result.isConfirmed && !!cb) {
                    cb();
                }
            });
        }

        return {
            confirmDelete,
            error,
            success
        };
    })();

    window.alert = alert;
});